export default __webpack_public_path__ + "static/media/Background 5_00038.3e2f42a5.png";